import React, { useState, useEffect, useRef } from 'react';

const Select = ({ value, onChange, options = [], style, buttonStyle, disabled }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const selected = options.find(o => String(o.value) === String(value));

  return (
    <div ref={ref} style={{ position: 'relative', width: '100%', ...style }}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => !disabled && setOpen(o => !o)}
        className={`custom-select-btn${open ? ' open' : ''}${disabled ? ' disabled' : ''}`}
        style={buttonStyle}
      >
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '5px' }}>
          {selected?.color && <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: selected.color, flexShrink: 0, display: 'inline-block' }} />}
          {selected ? selected.label : ''}
        </span>
        <svg
          width="11" height="11" viewBox="0 0 12 12"
          style={{ flexShrink: 0, transition: 'transform 0.15s', transform: open ? 'rotate(180deg)' : 'none', opacity: 0.5 }}
        >
          <path fill="currentColor" d="M6 9L1 4h10z" />
        </svg>
      </button>

      {open && (
        <div className="custom-select-list">
          {options.map(opt => {
            const isCurrent = String(opt.value) === String(value);
            return (
              <button
                key={opt.value}
                type="button"
                className={`custom-select-item${isCurrent ? ' current' : ''}`}
                onClick={() => { onChange(opt.value); setOpen(false); }}
              >
                <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  {opt.color && <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: opt.color, flexShrink: 0, display: 'inline-block' }} />}
                  {opt.label}
                </span>
                {isCurrent && (
                  <svg width="11" height="11" viewBox="0 0 12 12" style={{ flexShrink: 0, color: 'var(--color-primary)' }}>
                    <polyline points="1,6 4.5,9.5 11,2.5" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Select;
